const MathFunction = require("./MathFunction").MathFunction;
const solveCubic = require("./solveCubicEquation").solveCubic;

class Polynomial extends MathFunction {
    constructor(coefficients = [0]) {
        super();
        this.coefficients = coefficients;
    }

    calc(x) {
        let y = 0;
        let xToPowerOfI = 1;
        for (var i = 0; i < this.coefficients.length; i++) {
            y += this.coefficients[i] * xToPowerOfI;
            xToPowerOfI *= x;
        }
        return y;
    }

    simplyfy() {
        while (this.coefficients.length > 1) {
            if (this.coefficients[this.coefficients.length - 1] != 0)
                break;
            this.coefficients.length--;
        }
    }

    add(second) {
        let ret = [];
        for (var i = 0; i < this.coefficients.length || i < second.coefficients.length; i++) {
            ret[i] = (this.coefficients[i] || 0) + (second.coefficients[i] || 0);
        }
        return new Polynomial(ret);
    }

    subtract(second) {
        let ret = [];
        for (var i = 0; i < this.coefficients.length || i < second.coefficients.length; i++) {
            ret[i] = (this.coefficients[i] || 0) - (second.coefficients[i] || 0);
        }
        return new Polynomial(ret);
    }

    multiply(second) {
        let ret = [];
        for (var i = 0; i < this.coefficients.length; i++) {
            for (var j = 0; j < second.coefficients.length; j++) {
                if (!ret[i + j])
                    ret[i + j] = 0;
                ret[i + j] += this.coefficients[i] * second.coefficients[j];
            }
        }
        return new Polynomial(ret);
    }

    multiplyXByScalar(scalar) {
        let ret = [];
        for (var i = 0; i < this.coefficients.length; i++) {
            ret[i] = this.coefficients[i] * Math.pow(scalar, i);
        }
        return new Polynomial(ret);
    }

    get derriverance() {
        var ret = [];
        for (var i = 1; i < this.coefficients.length; i++) {
            ret[i - 1] = this.coefficients[i] * i;
        }
        return new Polynomial(ret);
    }

    calcZeroPoints() {
        this.simplyfy();
        if (this.coefficients.length > 4)
            throw new Error("Too hard to calc. Use calcZeroPointsBinary");
        var points = solveCubic(this.coefficients[3] || 0, this.coefficients[2] || 0, this.coefficients[1] || 0, this.coefficients[0] || 0);
        return points;
    }

    clone() {
        return new Polynomial(this.coefficients.slice());
    }
}

module.exports.Polynomial = Polynomial;